// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"4aec6ffa","453":"b75be733"}[chunkId] + ".chunk.js";
};